import { Penalty } from './penalty';
import { ScheduleRowEntity } from '../apis/schedule/schedule-row-entity';
export class ScheduleRowCollection {
    public isSaved: boolean = false;
    public selected: boolean = false;
    public penalty: Penalty = null;
    public games: ScheduleRowEntity[] = [];

    public updateGames(games: ScheduleRowEntity[]): void {
        this.games.clear();
        this.games.addRange(games);
    }
}
